/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { StageMappingOverride } from './stageMappingOverride';

export interface UpdateStageMappingsRequest {
  /** @maxItems 500 */
  overrides: StageMappingOverride[];
}
